import {
  CdkOverlayOrigin, OverlayRef, Overlay, GlobalPositionStrategy, ConnectedPosition
} from '@angular/cdk/overlay';
import { CdkPortal } from '@angular/cdk/portal';
import {
  Component, OnInit, ViewChild, EventEmitter, Input, SimpleChanges, OnChanges
} from '@angular/core';
import { takeUntil } from 'rxjs/operators';

import { BreakpointsService } from '@sondermind/utilities/services';

// copied from cdk
const defaultPositionList: ConnectedPosition[] = [
  {
    originX: 'start',
    originY: 'bottom',
    overlayX: 'start',
    overlayY: 'top'
  },
  {
    originX: 'start',
    originY: 'top',
    overlayX: 'start',
    overlayY: 'bottom'
  },
  {
    originX: 'end',
    originY: 'top',
    overlayX: 'end',
    overlayY: 'bottom'
  },
  {
    originX: 'end',
    originY: 'bottom',
    overlayX: 'end',
    overlayY: 'top'
  }
];
@Component({
  selector: 'sondermind-popup',
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.scss'],
  standalone: false
})
export class PopupComponent implements OnInit, OnChanges {
  @ViewChild('popup') popupTemplate: CdkPortal;

  @Input() origin: CdkOverlayOrigin;
  @Input() closeOnClick: boolean;
  @Input() offsetX: number;
  @Input() offsetY: number;
  @Input() opened: boolean;

  isOpened: boolean;
  isMobile: boolean;

  overlayRef: OverlayRef;

  destroyed$ = new EventEmitter();

  constructor(
    private breakpoint: BreakpointsService,
    private overlay: Overlay
  ) {}

  ngOnInit() {
    this.isOpened = false;
    this.breakpoint.isMobile$
      .pipe(takeUntil(this.destroyed$))
      .subscribe((m) => {
        this.isMobile = m;
      });
  }

  ngOnChanges(cs: SimpleChanges) {
    if (cs['opened']?.previousValue !== undefined) {
      this.isOpened = !cs['opened'].currentValue;
      this.changeState();
    }
  }

  popupClick() {
    if (this.closeOnClick) {
      this.changeState();
    }
  }

  changeState() {
    this.isOpened ? this.closePopup() : this.openPopup();
  }

  private openPopup() {
    if (this.overlayRef) { return }
    this.overlayRef = this.overlay.create({
      positionStrategy: this.getPositionStrategy(),
      scrollStrategy: this.getScrollStrategy(),
      hasBackdrop: true,
    });

    const evRef = this.overlayRef.attach(this.popupTemplate);
    this.overlayRef.detachments().subscribe(() => this.closePopup());
    this.overlayRef.backdropClick().subscribe(() => this.closePopup());
    this.overlayRef.keydownEvents().subscribe((e) => {
      this.closePopup();
      e.preventDefault();
    });

    this.isOpened = true;
  }

  private closePopup() {
    if (!this.overlayRef) { return }

    this.overlayRef.dispose();
    this.overlayRef = null;

    this.isOpened = false;
  }

  private getPositionStrategy() {
    if (this.isMobile) {
      return new GlobalPositionStrategy().centerHorizontally().centerVertically();
    }

    let pos = this.overlay.position().flexibleConnectedTo(this.origin.elementRef);
    pos = pos.withPositions(defaultPositionList);
    pos = pos.withViewportMargin(8);
    pos = pos.withFlexibleDimensions(false);
    pos = pos.withLockedPosition();
    pos = pos.withTransformOriginOn('.sonder-popup-dialog');

    // pos = pos.withDefaultOffsetX(this.offsetX);
    // pos = pos.withDefaultOffsetY(this.offsetY);

    return pos;
  }

  private getScrollStrategy() {
    if (this.isMobile) {
      return this.overlay.scrollStrategies.block();
    }

    return this.overlay.scrollStrategies.reposition();
  }
}
